export default {
  apiKey: 'FdjvxXtX6i3hCib8ymhrWMZ0agw9ttGnvcgNPhJR8ig',
  version: 'v8',
  endpoints: {
    routing: 'router.hereapi.com',
    isoline: 'isoline.router.hereapi.com',
    intermodal: 'intermodal.router.hereapi.com',
  },
};
